module.exports = __webpack_public_path__ + "img/SEGURIFY_GIF_GNP.fab6caaa.gif";